import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

export default function Regolamento() {
  return (
    <>
      <Helmet>
        <title>Regolamento | La Villa</title>
        <meta name="description" content="Regolamento della piscina La Villa - Norme di comportamento e sicurezza" />
      </Helmet>
      
      <div className="min-h-screen bg-ivory">
        {/* Hero */}
        <section className="pt-32 pb-16 px-6 md:px-12 lg:px-24 bg-night">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <p className="font-body text-xs uppercase tracking-[0.2em] text-champagne mb-4">
                La Villa
              </p>
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-ivory tracking-tight">
                Regolamento
              </h1>
            </motion.div>
          </div>
        </section>
        
        {/* Regolamento Image */}
        <section className="py-16 px-4 md:px-12 lg:px-24">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_08488fc2-8004-4b2e-8d3e-914d83bf1740/artifacts/5h1nocci_REGOLAMENTO.png"
                alt="Regolamento La Villa"
                className="w-full h-auto"
                data-testid="regolamento-image"
              />
            </motion.div>
          </div>
        </section>
      </div>
    </>
  );
}
